/* GOAT Life — pincode delivery estimator (snippets/shipping-estimator.liquid) */
(function () {
  if (customElements.get('shipping-estimator')) return;

  var STORAGE_KEY = 'goatlife:pincode';
  var MIN_DRIVE_MS = 1500;
  var dataCache = {};

  function loadData(src) {
    if (!dataCache[src]) {
      dataCache[src] = fetch(src)
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (json) {
          var map = new Map();
          Object.keys(json.days || {}).forEach(function (days) {
            json.days[days].split(',').forEach(function (pin) {
              map.set(pin, Number(days));
            });
          });
          return { map: map, defaultDays: Number(json.default_days) || 4 };
        })
        .catch(function () {
          // Lookup file unavailable: everyone gets the nationwide default.
          delete dataCache[src];
          return { map: new Map(), defaultDays: 4 };
        });
    }
    return dataCache[src];
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function readSaved() {
    try { return localStorage.getItem(STORAGE_KEY) || ''; } catch (e) { return ''; }
  }

  function save(pin) {
    try { localStorage.setItem(STORAGE_KEY, pin); } catch (e) {}
  }

  class ShippingEstimator extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.ship-est__form');
      this.input = this.querySelector('.ship-est__input');
      this.button = this.querySelector('.ship-est__btn');
      this.errorEl = this.querySelector('.ship-est__error');
      this.daysEl = this.querySelector('[data-days]');
      this.daysLabelEl = this.querySelector('[data-days-label]');
      this.headlineEl = this.querySelector('[data-headline]');
      this.dateEl = this.querySelector('[data-date]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var saved = readSaved();
      if (saved && !this.input.value) this.input.value = saved;

      this.input.addEventListener('input', this.onInput.bind(this));
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onInput() {
      var digits = this.input.value.replace(/\D/g, '').slice(0, 6);
      if (digits !== this.input.value) this.input.value = digits;
      if (this.dataset.state === 'error') this.setState('idle');
    }

    setState(state) {
      this.dataset.state = state;
    }

    // Snap the truck back to the start without animating, so every search replays the drive.
    resetScene() {
      this.classList.add('is-resetting');
      this.setState('idle');
      void this.offsetWidth;
      this.classList.remove('is-resetting');
    }

    showError(message) {
      this.errorEl.textContent = message;
      this.resetScene();
      this.setState('error');
      this.input.focus();
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.dataset.state === 'driving') return;

      var pin = this.input.value.trim();
      if (!/^[1-9]\d{5}$/.test(pin)) {
        this.showError('Please enter a valid 6-digit pincode.');
        return;
      }

      save(pin);
      this.resetScene();
      this.setState('driving');
      this.button.disabled = true;

      var results = await Promise.all([
        loadData(this.dataset.src),
        wait(this.reducedMotion ? 0 : MIN_DRIVE_MS)
      ]);
      var data = results[0];
      var days = data.map.get(pin) || data.defaultDays;

      this.render(pin, days, data.map.has(pin));
      this.setState('arrived');
      this.button.disabled = false;
    }

    render(pin, days, isExpress) {
      var eta = new Date();
      eta.setDate(eta.getDate() + days);
      var etaText = eta.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });

      this.daysEl.textContent = days;
      this.daysLabelEl.textContent = days === 1 ? 'day' : 'days';
      this.headlineEl.textContent = isExpress
        ? 'Zooming to ' + pin + ' in ' + days + ' days!'
        : 'Delivering to ' + pin + ' in ' + days + ' days';

      var strong = document.createElement('b');
      strong.textContent = etaText;
      this.dateEl.replaceChildren('Expected by ', strong);
    }
  }

  customElements.define('shipping-estimator', ShippingEstimator);
})();
